export const PT_MONTHS = ["", "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

export const METRIC_LABELS = {
  events_published: "Eventos realizados",
  events_done: "Eventos concluídos",
  fill_rate: "Taxa de preenchimento",
  time_to_team: "Tempo para montar equipe",
  avg_rating: "Avaliação média",
  events_clean: "Eventos sem ocorrência",
  earnings: "Meta de ganhos",
  shows_done: "Shows realizados",
  contratacoes: "Contratações",
  taxa_aprovacao: "Taxa de aprovação",
  cache_medio: "Cachê médio",
  pontualidade: "Pontualidade",
  candidaturas: "Candidaturas",
};

export const METRIC_UNIT = {
  fill_rate: "%", taxa_aprovacao: "%", pontualidade: "%",
  earnings: "R$", cache_medio: "R$", time_to_team: "h", avg_rating: "★",
};

export function periodLabel(value) {
  if (!value) return "";
  if (value.includes("-Q")) { const [y, q] = value.split("-Q"); return `${q}º trimestre de ${y}`; }
  if (value.includes("-")) { const [y, m] = value.split("-"); return `${PT_MONTHS[parseInt(m)]} de ${y}`; }
  return value;
}

export function periodOptions(gran) {
  const now = new Date();
  const opts = [];
  if (gran === "quarter") {
    let q = Math.floor(now.getMonth() / 3) + 1, y = now.getFullYear();
    for (let i = 0; i < 6; i++) { opts.push(`${y}-Q${q}`); q--; if (q < 1) { q = 4; y--; } }
  } else if (gran === "year") {
    for (let i = 0; i < 3; i++) opts.push(`${now.getFullYear() - i}`);
  } else {
    for (let i = 0; i < 12; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      opts.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    }
  }
  return opts;
}
